import { useState } from "react";
import "./Login.css";
import logo from "../Assets/crucible_circle.png";

const Login = ({ login, errorMessage, version }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    return (
        <main>
            <form action="" method="post">
                <div className="logo-container logo-container-margin">
                    <img className="logo login-logo" src={logo} />
                    <div style={{ position: "relative" }}>
                        <h1 className="login-h1">FORGE</h1>
                        <p className="version-num version-num-bigger login-p">v{version}</p>
                    </div>
                </div>
                <input
                    type="text"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type="submit" onClick={(e) => login(e, email, password)}>
                    LOGIN
                </button>

                {errorMessage && <span className="errorMessage">{errorMessage}</span>}
            </form>
        </main>
    );
};

export default Login;
